import script from "./OpularDisease.vue?vue&type=script&setup=true&lang=js"
export * from "./OpularDisease.vue?vue&type=script&setup=true&lang=js"

import "./OpularDisease.vue?vue&type=style&index=0&id=b82f4534&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b82f4534"]])

export default __exports__